/**
 * Remembers which folder on disk belongs to which project (per device, in IndexedDB). Shared by
 * the project store (project file) and the local-folder media provider (media files), so one
 * permission grant covers both.
 */
import { kv } from '../media/idb.ts';

const key = (projectId: string) => `project-folder:${projectId}`;

export interface ProjectFolders {
  get(projectId: string): Promise<FileSystemDirectoryHandle | undefined>;
  set(projectId: string, folder: FileSystemDirectoryHandle): Promise<void>;
  delete(projectId: string): Promise<void>;
}

export const projectFolders: ProjectFolders = {
  get: (projectId) => kv.get<FileSystemDirectoryHandle>(key(projectId)),
  set: (projectId, folder) => kv.set(key(projectId), folder),
  delete: (projectId) => kv.delete(key(projectId)),
};

/** In-memory implementation (tests). */
export function memoryFolders(): ProjectFolders {
  const map = new Map<string, FileSystemDirectoryHandle>();
  return {
    get: async (id) => map.get(id),
    set: async (id, folder) => {
      map.set(id, folder);
    },
    delete: async (id) => {
      map.delete(id);
    },
  };
}
